<template>
  <div class="c-teamwork c-standard">
    <h3 class='title_h3'>{{ text.title }}</h3>
    <p>{{ text.teamworkContent }}</p>
    <div class="c-teamwork__items">
      <div class="c-teamwork__item" v-for="(item, index) in teamwork" :key='index'>
        <img :src="item.img" :alt="item.des">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'teamWork',
    // props: ['contact'],
    data(){
      return{
        text:{
          title: this.$t('team_work.title'),
          teamworkContent: ''
        },
        teamwork: [
          {img: require('../../assets/img/partner_logo_05whd.png'), des: ''},
          {img: require('../../assets/img/partner_logo_01bosserhoff.jpg'), des:''},
          // {img: require('../../assets/img/partner_logo_02horcher.jpg'), des:''},
          {img: require('../../assets/img/partner_logo_03pressalit.jpg'), des:''},
          {img: require('../../assets/img/partner_logo_04peha.jpg'), des:''},
        ]
      }
    },
    computed: {

    },
    methods:{

    },
    created(){

    }
  }
</script>

<style>


</style>
